module.exports = "/build/admin/images/favicon-96x96.1fda1d15.png";